<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12">
        <v-card>
          <v-card-title v-if="items != null">
            {{ $t("servicesystem.common_objects.kpi.service_volume") }}
          </v-card-title>
          <v-card-title v-else>
            {{ $t("servicesystem.common_objects.fallbackterms.loading") }}
          </v-card-title>
          <v-progress-linear indeterminate v-if="items == null"></v-progress-linear>
          <v-toolbar flat>
            <v-select :label="$t('servicesystem.common_objects.commonterms.month')" :items="monthSelection"
              item-text="name" item-value="id" v-model="queryPreset.Month" hide-details dense :disabled="loading"
              @change="getByPreset(queryPreset)">
            </v-select>
            <v-select :label="$t('servicesystem.common_objects.commonterms.year')" :items="yearSelection"
              v-model="queryPreset.Year" hide-details dense :disabled="loading" @change="getByPreset(queryPreset)">
            </v-select>
            <v-select label="Selection" :items="groupSelection" v-model="queryPreset.GroupBy" hide-details dense
              :disabled="loading" @change="getByPreset(queryPreset)">
            </v-select>
            <v-select label="Status selection" :items="statusSelection" v-model="queryPreset.JobStatuses"
              :multiple="true" hide-details dense :disabled="loading" @change="getByPreset(queryPreset)">
            </v-select>
            <v-divider vertical class="mx-2" />
            <v-btn color="primary" @click="exportFile">
              {{ $t("servicesystem.common_objects.commonterms.export") }}
            </v-btn>
          </v-toolbar>
          <v-card-text v-if="items && items.length > 0">
            <DxChart id="chart" :data-source="items" palette="Soft">
              <DxCommonSeriesSettings argument-field="date" type="stackedbar" />
              <DxLegend vertical-alignment="bottom" horizontal-alignment="center" />
              <DxArgumentAxis argument-type="datetime" aggregation-interval="day"> <!-- Interval of one day -->
                <DxAggregationInterval :days="1" />
              </DxArgumentAxis>
              <DxSeries value-field="value" :name="serviceJobsLabel" />
              <DxSeries value-field="pmValue" :name="pmJobsLabel" />
              <DxSeries value-field="supportValue" :name="supportJobsLabel" />
              <DxSeries value-field="partsValue" :name="partsJobsLabel" />
              <!--
              <DxZoomAndPan argument-axis="both"
              value-axis="both" /> 
            -->
              <!-- or "zoom" | "pan" | "none" -->
              <DxTooltip :enabled="true" :customize-tooltip="customizeTooltip" />
            </DxChart>
          </v-card-text>
          <v-card-text v-if="items && items.length == null">
            {{ $t('servicesystem.common_objects.fallbackterms.no_items') }}
          </v-card-text>
          <v-card-text>
            <DxDataGrid :data-source="gridSource" :show-borders="true" :columns="columns">
              <DxFilterRow :visible="true" />
              <DxColumn :group-index="0" data-field="Customer"
                :caption="$t('servicesystem.common_objects.customer.customer')">
              </DxColumn>
              <DxColumn data-field="Machine" :caption="$t('servicesystem.common_objects.machine.machine')">
              </DxColumn>
              <DxColumn data-field="JobType" width="10%" :caption="$t('servicesystem.common_objects.job.type')">
              </DxColumn>
              <DxColumn data-type="date" width="10%" data-field="Created"
                :caption="$t('servicesystem.common_objects.kpi.created_date')">
              </DxColumn>
              <DxColumn data-type="date" width="10%" data-field="Planned"
                :caption="$t('servicesystem.common_objects.kpi.planned_date')">
              </DxColumn>
              <DxColumn data-type="date" width="10%" data-field="Completed"
                :caption="$t('servicesystem.common_objects.kpi.completed_date')">
              </DxColumn>
              <DxColumn data-type="date" width="10%" data-field="Closed"
                :caption="$t('servicesystem.common_objects.kpi.closed_date')">
              </DxColumn>
              <DxColumn data-field="JobStatus" :width="120" :caption="$t('servicesystem.common_objects.job.status')">
              </DxColumn>
              <DxColumn type="buttons" :width="60">
                <DxButton text="Ok" :hint="$t('servicesystem.common_objects.commonterms.open')" icon="arrowright" :on-click="openJob">
                </DxButton>
              </DxColumn>
            </DxDataGrid>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import client from "@/api/client";
import DxChart, { DxAggregationInterval, DxArgumentAxis, DxCommonSeriesSettings, DxLegend, DxSeries, DxTooltip /* , DxZoomAndPan */ } from "devextreme-vue/chart";
import DxDataGrid, { DxButton, DxColumn, DxFilterRow } from "devextreme-vue/data-grid";
import JTConstants from "@/helpers/Constants/JobTypeConstants";

export default {
  name: "ServiceVolumeGraph",
  props: [],
  components: {
    DxButton, DxColumn, DxFilterRow, DxAggregationInterval,
    DxArgumentAxis,
    DxChart,
    DxSeries,
    DxCommonSeriesSettings,
    DxLegend,
    /*DxZoomAndPan,*/
    DxTooltip,
    DxDataGrid
  },

  data() {
    return {
      loading: false,
      items: null,
      gridSource: null,
      columns: [],
      monthSelection: [],
      yearSelection: [],
      groupSelection: ["Closed", "Completed", "Planned", "Created"],
      statusSelection: ["Closed", "Completed", "Planned", "Created"],
      queryPreset: {
        JobStatuses: ['Closed', 'Created'],
        VolumeDateType: 'Month',
        Month: (new Date()).getMonth() + 1,
        Year: (new Date()).getFullYear(),
        GroupBy: 'Closed',
        Type: "KPI"
      }
    };
  },

  mounted() {
    function monthName(month) {
      const dt = new Date();
      dt.setDate(1);
      dt.setMonth(month - 1);
      return dt.toLocaleDateString([], { month: 'long' })
    }
    for (let index = 1; index < 13; index++) {
      this.monthSelection.push({
        id: index,
        name: monthName(index)
      })
    }
    for (let index = 2020; index < (new Date().getFullYear() + 1); index++) {
      this.yearSelection.push(index)
    }

    this.getByPreset(this.queryPreset)
  },
  methods: {
    exportFile() {
      client()
        .post(`/api2/serviceprovider/statistics/export`, this.queryPreset)
    },
    getByPreset(preset) {
      this.loading = true;
      this.items = null;
      this.gridSource = null;
      const statuses = 'JobStatuses=' + preset.JobStatuses.join('&JobStatuses=');
      try {

        client()
          .get(`/api2/serviceprovider/statistics/servicevolume?${statuses}&VolumeDateType=${preset.VolumeDateType}&Month=${preset.Month}&GroupBy=${preset.GroupBy}&Year=${preset.Year}`)
          .then((response) => {
            this.items = response.data;
            this.items = this.items.map((v) => {
              v.date = new Date(v.date);
              return v;
            });
          });
        client()
          .get(`/api2/serviceprovider/statistics/servicevolume/data?${statuses}&VolumeDateType=${preset.VolumeDateType}&Month=${preset.Month}&GroupBy=${preset.GroupBy}&Year=${preset.Year}`)
          .then((response) => {
            this.gridSource = response.data;
            this.gridSource = this.gridSource.map((v) => {
              v.Created = new Date(v.Created);
              v.Planned = v.Planned ? new Date(v.Planned) : null;
              v.Completed = v.Completed ? new Date(v.Completed) : null;
              v.Closed = v.Closed ? new Date(v.Closed) : null;
              return v;
            });
          });
      }
      finally {
        this.loading = false;
      }
    },
    customizeTooltip(args) {
      return {
        text: `${args.argument.toLocaleDateString()}<br/>${args.seriesName}: ${args.value}`
      }
    },
    openJob(args) {
      this.$router.push({ name: 'ViewJob', params: { filter: 'my', jobId: args.row.data.JobId } });
    }
  },

  computed: {
    jobTypeList() {
      var list = this.$store.getters["LookUpStore/JobTypeList"];
      return list && list.length ? list : [];
    },
    serviceJobsLabel() {
      return this.jobTypeList.find((x) => x.Id == JTConstants.JOBTYPE_SERVICE)?.Name || 'Service';
    },
    supportJobsLabel() {
      return this.jobTypeList.find((x) => x.Id == JTConstants.JOBTYPE_SUPPORT)?.Name || 'Support';
    },
    pmJobsLabel() {
      return this.jobTypeList.find((x) => x.Id == JTConstants.JOBTYPE_SCHEDULEDSERVICE)?.Name || 'Preventive Maintenance';
    },
    partsJobsLabel() {
      return this.jobTypeList.find((x) => x.Id == JTConstants.JOBTYPE_PARTS)?.Name || 'Parts order';
    }
  },

  watch: {},
};
</script>


<style lang='scss' scoped></style>